import http from "api/https";

export const getstatuses = (): Promise<any> => {
  return http.get("/status/GetAll");
};


